import { formatPercentCell } from '../../../../utils/formatPercent';

interface IChartRow {
  label: string;
  actual: number;
  earned: number;
  productivity: number | null;
}

/** Two-line X-axis tick: the date on top, the bucket's productivity % beneath it.
 *  The % is shown only when the bucket has on-site presence (`actual > 0`) — an
 *  empty bucket has no meaningful ratio, so we omit it rather than print 0%. */
export function ChartTick(props: { x?: number; y?: number; payload?: { index: number }; rows: IChartRow[] }) {
  const { x = 0, y = 0, payload, rows } = props;
  const row = payload ? rows[payload.index] : undefined;
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={12} textAnchor="middle" fill="var(--g500)" fontSize={11}>
        {row?.label}
      </text>
      {row && row.actual > 0 ? (
        <text x={0} y={0} dy={26} textAnchor="middle" fill="var(--g400)" fontSize={10}>
          {formatPercentCell(row.productivity)}
        </text>
      ) : null}
    </g>
  );
}